function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 0L5 .25V1h1zm0 1v1H5V1c-1.258.015-2.179-.03-2.931.385-.377.208-.676.56-.84.998-.165.439-.223.96-.223 1.617v8c0 .658.058 1.179.223 1.617.164.44.463.789.84.997.752.415 1.673.372 2.931.386h3.004v-1H5c-1.26-.014-2.087-.06-2.453-.261-.183-.102-.29-.213-.387-.473C2.062 13.006 2 12.593 2 12V7c0-.592.063-1.005.16-1.265.098-.26.204-.372.387-.473.367-.202 1.195-.247 2.459-.262H11c1.26.015 2.087.06 2.453.262.184.101.29.213.387.473C13.938 5.995 14 7 14 7v1h1V4c0-.657-.06-1.178-.225-1.617a1.88 1.88 0 0 0-.837-.998c-.753-.415-1.674-.37-2.932-.385v1h-1V1zm4 0h1V0l-1 .25z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      textTransform: "none",
      isolation: "auto",
      mixBlendMode: "normal",
      marker: "none"
    },
    color: "#000000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "#5b016f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "error",
    d: "M12.5 9A3.5 3.5 0 0 0 9 12.5a3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12.5 9zm-.5 1h1v1.168c0 .349-.016.668-.047.957-.03.29-.069.581-.115.875h-.666a12.898 12.898 0 0 1-.125-.875 9.146 9.146 0 0 1-.047-.957zm.5 4a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5z",
    style: {
      marker: "none"
    },
    color: "#000000",
    overflow: "visible",
    fill: "#f22c42"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentMissed);
export default __webpack_public_path__ + "static/media/appointment-missed.1aafebab2ddee9b0c6f5501b372a7870.svg";
export { ForwardRef as ReactComponent };